//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
export default {
  name: 'c_txt_tab',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    }
  },
  data: function data() {
    return {
      defaults: {},
      configData: {}
    };
  },
  created: function created() {
    this.defaults = this.configObj;
    this.configData = this.configObj[this.configNme];
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    radioChange: function radioChange(e) {
      //防止魔方样式一出现两张图的情况
      if (this.configData.name === 'pictureCure') {
        this.configObj['picStyle'].tabVal = 0;
      }
      if (this.configData.name !== 'itemStyle' && this.configData.name !== 'bgStyle' && this.configData.name !== 'contentStyle') {
        this.$emit('getConfig', {
          name: 'radio',
          values: e
        });
      }
      e !== 0 && this.configObj['checkoutConfig'] && (this.configObj['checkoutConfig']['checkoutVal'] = '1');
    }
  }
};